var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPurpleLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 46,
    viewBox: "0 0 48 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 288"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3963",
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 45,
    rx: 4.5,
    stroke: "#880CE8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_665_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_667_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_669_",
    d: "M17.4313 19.0049H12.4766V35.0127H17.4313V19.0049Z",
    fill: "#880CE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_668_",
    d: "M14.9301 16.9078C16.5491 16.9078 17.8601 15.584 17.8601 13.9533C17.8601 12.3227 16.5491 11 14.9301 11C13.311 11 12 12.3227 12 13.9533C12 15.584 13.311 16.9078 14.9301 16.9078Z",
    fill: "#880CE8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_666_",
    d: "M25.3502 26.608C25.3502 24.3578 26.3857 23.0166 28.3697 23.0166C30.1921 23.0166 31.0673 24.3032 31.0673 26.608C31.0673 28.9139 31.0673 35.0111 31.0673 35.0111H35.9988C35.9988 35.0111 35.9988 29.1637 35.9988 24.8762C35.9988 20.5886 33.5685 18.5151 30.1747 18.5151C26.7797 18.5151 25.3513 21.1604 25.3513 21.1604V19.0044H20.5977V35.0122H25.3513C25.3513 35.0122 25.3502 29.0743 25.3502 26.608Z",
    fill: "#880CE8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleLinkedin);
export default __webpack_public_path__ + "static/media/purple_linkedin.955a24339c7a76e5ff7ac20e76a06882.svg";
export { ForwardRef as ReactComponent };